import React, { FC, memo } from 'react';

import InputSearch, { InputSize } from '@zvuk-b2b/react-uikit/ui/InputSearch';
import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';
import Switcher, { LabelPlacement } from '@zvuk-b2b/react-uikit/ui/Switcher';
import IconInfo from '@zvuk-b2b/react-uikit/ui/icons/Info';

import { AUDIO_REPORT_ADDRESSES_EXACT_TOOLTIP_OFFSET, DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import AddressTagFilterOption from './AddressTagFilterOption';
import type { AddressTagFilterDropdownProps } from './types';

import styles from '../index.module.scss';

const AddressTagFilterDropdown: FC<AddressTagFilterDropdownProps> = ({
  filteredTags,
  isExactSearch,
  containerRef,
  selectedTagSet,
  tagSearch,
  onExactSearchChange,
  onSearchChange,
  onTagChange,
}) => (
  <div
    ref={containerRef}
    className={styles.tagFilter}
    data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TAG_FILTER}>
    <InputSearch
      elementId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TAG_FILTER_SEARCH}
      value={tagSearch}
      placeholder={TEXTS.AUDIO_REPORT_ADDRESSES_TAG_SEARCH_PLACEHOLDER}
      size={InputSize.SMALL}
      containerClassName={styles.tagFilterSearch}
      inputClassName={styles.searchInput}
      onChange={onSearchChange}
    />

    <div className={styles.exactSearch}>
      <Switcher
        elementId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_EXACT_TOGGLE}
        labelPlacement={LabelPlacement.RIGHT}
        labelClassName={styles.exactSearchSwitcherLabel}
        isChecked={isExactSearch}
        onChange={onExactSearchChange}>
        <span className={styles.exactSearchLabel}>
          {TEXTS.AUDIO_REPORT_ADDRESSES_EXACT_SEARCH}
          <Popper
            elementId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_EXACT_TOOLTIP}
            popperClassName={styles.tooltipPopper}
            placement={HintPlacement.PLACEMENT_TOP}
            offset={AUDIO_REPORT_ADDRESSES_EXACT_TOOLTIP_OFFSET}
            portalNode={document.body}
            triggerNode={
              <span data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_EXACT_INFO}>
                <IconInfo className={styles.infoIcon} />
              </span>
            }>
            <span className={styles.tooltip}>{TEXTS.AUDIO_REPORT_ADDRESSES_EXACT_SEARCH_TOOLTIP}</span>
          </Popper>
        </span>
      </Switcher>
    </div>

    <ul className={styles.tagList}>
      {filteredTags.map((tag) => (
        <AddressTagFilterOption
          key={tag.id}
          isChecked={selectedTagSet.has(tag.id)}
          tag={tag}
          onChange={onTagChange}
        />
      ))}
    </ul>
  </div>
);

export default memo(AddressTagFilterDropdown);
